export default __webpack_public_path__ + "static/media/email-not-verify.42098f07.svg";